import { responseStatus } from "../constants";
import { ApiPaths, apiService } from "../helpers/api";
import { NhanVienTheoToBan, TimKiemToBanResponse, ToBan, ToBanRequest } from "../models/toban/ToBan";
import intance from "../utils/axios";

export const timKiemDSToBan = async (tuKhoa: string) => {
    var data: Array<TimKiemToBanResponse> = [];
    await intance.post(ApiPaths.toBan.timKiemDSToBan, {
        "start": 0,
        "length": 0,
        "filter": {
            "tuKhoa": tuKhoa
        },
        "orderBy": {
            "columnName": "ten",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu.data;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};
export const luuToBan = async (request: ToBanRequest) => {
    var response = 0;
    const formData = new FormData();
    formData.append("id", (!!request.id ? request.id : "").toString());
    formData.append("ten", request.ten?.toString() || "");
    formData.append("soQuyetDinh", request.soQuyetDinh?.toString() || "");
    formData.append("moTa", request.moTa?.toString() || "");
    formData.append("ngayBatDauStr", request.ngayBatDau?.toString() || "");
    formData.append("ngayKetThucStr", request.ngayKetThuc?.toString() || "");
    formData.append("ngayKyQuyetDinhStr", request.ngayKyQuyetDinh?.toString() || "");
    formData.append("trangThai", request.trangThai?.toString() || "0");
    request.files.forEach((file, index) => {
        formData.append("files", file);
    });
    request.idsTaiLieuToBanXoa.forEach((item, index) => {
        formData.append("idsTaiLieuToBanXoa", item.toString());
    });
    request.dsNhanVien.forEach((item, index) => {
        formData.append(`dsNhanVien[${index}].idNhanVien`, item.idNhanVien.toString() || "0");
        formData.append(`dsNhanVien[${index}].chucDanh`, item.chucDanh.toString() || "");
    });
    await intance.post(ApiPaths.toBan.luu, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            } else {
                response = res.data.duLieu;
            }
        })
        .catch(err => {
        });
    return response;
};
export const layChiTiet = async (id: number) => {
    var data = new ToBan;
    await intance.get(ApiPaths.toBan.chitiet + "?id=" + id)
        .then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        }
    })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const xoaToBan = async (id: number) => {
    await intance.post(ApiPaths.toBan.xoa + "?id=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const luuDSNhanVien = async (data: any) => {
    await intance.post(ApiPaths.toBan.luuDsNhanVien, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}
